import { NavLink } from "react-router-dom";

const SidebarItem = ({ to, children, end = false }) => {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        [
          "flex items-center gap-2 text-[14.5px] transition-colors",
          isActive ? "text-black font-medium" : "text-[#6D6D6D] hover:text-black",
        ].join(" ")
      }
    >
      {({ isActive }) => (
        <>
          <span className={isActive ? "text-black" : "text-[#9A9A9A]"}>{">"}</span>
          <span>{children}</span>
        </>
      )}
    </NavLink>
  );
};

export default SidebarItem;